import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import type { Question } from '@/types/form'

interface QuestionSettingsProps {
  question: Question
  onChange: (patch: Partial<Question['settings']>) => void
}

export function NPSSettings({ question, onChange }: QuestionSettingsProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="rounded-md border border-slate-200 bg-slate-50 p-3 text-sm text-slate-600">
        NPS 量表固定為 0-10。
      </div>
      <div className="flex flex-col gap-2">
        <Label>低分標籤</Label>
        <Input
          value={question.settings.startLabel ?? '完全不推薦'}
          onChange={(event) => onChange({ startLabel: event.target.value })}
        />
      </div>
      <div className="flex flex-col gap-2">
        <Label>高分標籤</Label>
        <Input
          value={question.settings.endLabel ?? '極力推薦'}
          onChange={(event) => onChange({ endLabel: event.target.value })}
        />
      </div>
    </div>
  )
}
